import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  contractCrudService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'companyModel',
    'contractModel',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      Company,
      Contract
    ) {
      'use strict';

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }

        if (err.ModelState) {
          return {
            title: $filter('translate')('ERROR'),
            text: $filter('translate')('VERIFY FIELD ERRORS'),
            modelState: err.ModelState,
          };
        }

        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')('ERROR SAVING CONTRACT'),
        };
      }

      function sortColumns() {
        return [
          {
            column: 'companyName',
            title: 'COMPANY NAME',
            type: 'text',
            sortOrder: 'asc',
          },
        ];
      }

      function extraActions() {
        var deferred = $q.defer();
        deferred.resolve([]);
        return deferred.promise;
      }

      function listFilters() {
        var deferred = $q.defer();
        var filters = null;
        deferred.resolve(filters);
        return deferred.promise;
      }

      function list() {
        var deferred = $q.defer();

        var url = 'contracts';

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new Contract(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function save(contract) {
        contract.companies = null;
        var deferred = $q.defer();
        contract.idContractStatus = contract.contractStatus.id;
        var url = 'contracts';

        if (contract.id === 0) {
          $http.post(webApiSettings.apiServiceBaseUri + url, contract).then(
            function () {
              deferred.resolve(true);
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );
        } else {
          $http.put(webApiSettings.apiServiceBaseUri + url, contract).then(
            function () {
              deferred.resolve(true);
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );
        }

        return deferred.promise;
      }

      function load(id) {
        var deferred = $q.defer();

        if (id) {
          var url = 'contracts/' + id;
          $http
            .get(webApiSettings.apiServiceBaseUri + url)
            .then((results) => {
              var contractResolved = resolveReferences(results.data);
              var contract = new Contract(contractResolved);

              contractResolved.Companies.forEach(function (d) {
                var company = new Company(d);
                contract.companies.push(company);
              });

              deferred.resolve(contract);
            })
            .catch((err) => {
              handleError(err.data, err.status);
              deferred.reject(err);
            });
        } else {
          deferred.resolve(new Contract());
        }

        return deferred.promise;
      }

      function _delete(itens) {
        var deferred = $q.defer();

        var url = 'contracts/removelist/';
        var ids = [];
        for (var j = 0; j < itens.length; j++) {
          ids.push(itens[j].id);
        }

        $http.post(webApiSettings.apiServiceBaseUri + url, ids).then(
          function () {
            deferred.resolve(true);
          },
          function (err) {
            if (err.data.ModelState) {
              if (err.data.ModelState.ContractHasCompanies) {
                deferred.reject({
                  title: $filter('translate')('CONTRACT HAS COMPANIES'),
                  text: err.data.ModelState.ContractHasCompanies[0],
                });
              }
            }

            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function run() {
        try {
          var contractCrudFactory = {};

          contractCrudFactory.sortColumns = logWrapper(
            sortColumns,
            runtimeConstant.isDebugServicesInternals
          );
          contractCrudFactory.extraActions = logWrapper(
            extraActions,
            runtimeConstant.isDebugServicesInternals
          );
          contractCrudFactory.listFilters = logWrapper(
            listFilters,
            runtimeConstant.isDebugServicesInternals
          );
          contractCrudFactory.list = logWrapper(
            list,
            runtimeConstant.isDebugServicesInternals
          );
          contractCrudFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          contractCrudFactory.delete = logWrapper(
            _delete,
            runtimeConstant.isDebugServicesInternals
          );
          contractCrudFactory.load = logWrapper(
            load,
            runtimeConstant.isDebugServicesInternals
          );

          return contractCrudFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
